import { Package } from 'lucide-react';
import { Badge } from '../ui/badge';

export function OrdersTab({ orders }) {
  if (orders.length === 0) {
    return (
      <div className="text-center py-16 bg-surface rounded-2xl border border-[#262626]">
        <Package className="w-16 h-16 mx-auto mb-4 text-[#333]" />
        <h3 className="text-xl font-heading font-bold mb-2">No Orders Yet</h3>
        <p className="text-[#A1A1AA]">Orders will appear here when customers place them</p>
      </div>
    );
  }

  return (
    <div className="bg-surface border border-[#262626] rounded-xl overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-[#262626]">
              <th className="text-left p-4 text-sm font-medium text-[#A1A1AA]">Order ID</th>
              <th className="text-left p-4 text-sm font-medium text-[#A1A1AA]">Customer</th>
              <th className="text-left p-4 text-sm font-medium text-[#A1A1AA]">Artist</th>
              <th className="text-left p-4 text-sm font-medium text-[#A1A1AA]">Amount</th>
              <th className="text-left p-4 text-sm font-medium text-[#A1A1AA]">Platform Fee</th>
              <th className="text-left p-4 text-sm font-medium text-[#A1A1AA]">Status</th>
              <th className="text-left p-4 text-sm font-medium text-[#A1A1AA]">Date</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order) => (
              <tr key={order.id} className="border-b border-[#262626] last:border-0">
                <td className="p-4 font-mono text-sm">{order.id.slice(0, 8)}</td>
                <td className="p-4"><div><p className="font-medium">{order.user_name}</p><p className="text-xs text-[#A1A1AA]">{order.user_email}</p></div></td>
                <td className="p-4">{order.artist_name}</td>
                <td className="p-4 font-mono">${order.price.toFixed(2)}</td>
                <td className="p-4 font-mono text-lime">${(order.platform_fee || order.price * 0.1).toFixed(2)}</td>
                <td className="p-4"><Badge className="capitalize">{order.status.replace('_', ' ')}</Badge></td>
                <td className="p-4 text-sm text-[#A1A1AA]">{new Date(order.created_at).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
